import { containsExtent } from "ol/extent";
import getPaddedViewExtent from "./getPaddedViewExtent";
export default function containsExtentWithPadding(map, extent, padding) {
    const viewExtent = padding
        ? getPaddedViewExtent(map, padding)
        : map.getView().calculateExtent(map.getSize());
    return viewExtent && containsExtent(viewExtent, extent);
}
